import Link from 'next/link';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { ChevronRight } from '@fagmobler/ui';

type VariantShowMoreButtonProps = {
  onClick: () => void;
  type: 'text' | 'image';
  name: string;
};

export default function VariantShowMoreButton({
  onClick,
  type,
  name,
}: VariantShowMoreButtonProps) {
  return (
    <button
      onClick={onClick}
      className={twMerge(
        clsx(
          'p-2 border border-neutral-40 rounded hover:border-secondary-60 hover:bg-secondary-30 flex gap-1 items-center',
          {
            'flex-col gap-2 justify-center': type === 'image',
          }
        )
      )}
    >
      <span className="cap-xs font-bold">Flere {name}</span>
      <ChevronRight className="w-4 h-4" />
    </button>
  );
}
